import { formatISOWithOptions } from 'date-fns/fp';
import { pipe } from 'lodash/fp';
import ensureParseISO from './ensureParseISO';
export var formatDateServer = pipe(ensureParseISO, formatISOWithOptions({
  representation: 'date'
}));
export default formatDateServer;